import { render, staticRenderFns } from "./widgeform.vue?vue&type=template&id=6993946c&scoped=true&"
import script from "./widgeform.vue?vue&type=script&lang=js&"
export * from "./widgeform.vue?vue&type=script&lang=js&"
import style0 from "./widgeform.vue?vue&type=style&index=0&id=6993946c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6993946c",
  null
  
)

export default component.exports